import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BlogDetails from "../components/BlogDetails";
import fetchBlogDetails from "../api/blogDetailsApi";

const BlogDetailsPage = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getBlogDetails = async () => {
      try {
        const data = await fetchBlogDetails(id);
        setBlog(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getBlogDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading blogs...</p>
      </div>
    );
  }
  if (error) return <div>Error fetching blog details.</div>;
  if (!blog) return <div>Blog not found.</div>;

  return <BlogDetails blog={blog} />;
};

export default BlogDetailsPage;
